export default class Camera {
  constructor() {
    this.x = 0
    this.y = 0
    this.zoom = 1
    this.minZoom = 0.45
    this.maxZoom = 2.6
    this.viewport = { width: 1, height: 1 }
  }

  setViewport(viewport) {
    this.viewport = {
      width: viewport.width,
      height: viewport.height
    }
  }

  worldToScreen(x, y) {
    return {
      x: (x - this.x) * this.zoom + this.viewport.width / 2,
      y: (y - this.y) * this.zoom + this.viewport.height / 2
    }
  }

  screenToWorld(x, y) {
    return {
      x: (x - this.viewport.width / 2) / this.zoom + this.x,
      y: (y - this.viewport.height / 2) / this.zoom + this.y
    }
  }

  panBy(deltaX, deltaY) {
    this.x -= deltaX / this.zoom
    this.y -= deltaY / this.zoom
  }

  zoomAt(screenX, screenY, zoomDelta) {
    const worldBefore = this.screenToWorld(screenX, screenY)
    const nextZoom = Math.min(this.maxZoom, Math.max(this.minZoom, this.zoom * zoomDelta))

    if (nextZoom === this.zoom) {
      return
    }

    this.zoom = nextZoom

    const worldAfter = this.screenToWorld(screenX, screenY)
    this.x += worldBefore.x - worldAfter.x
    this.y += worldBefore.y - worldAfter.y
  }
}
